import { render, staticRenderFns } from "./CreateFirstparty.vue?vue&type=template&id=50cf9c14"
import script from "./CreateFirstparty.vue?vue&type=script&lang=js"
export * from "./CreateFirstparty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports